var map = {
	"./Baltic_Main.jpg": 170,
	"./Chimera_Main.jpg": 171,
	"./Desert_Main.jpg": 172,
	"./DihorOtok_Main.jpg": 173,
	"./Erangel_Main.jpg": 174,
	"./Heaven_Main.jpg": 175,
	"./Kiki_Main.jpg": 176,
	"./Neon_Main.jpg": 177,
	"./Savage_Main.jpg": 178,
	"./Summerland_Main.jpg": 179,
	"./Tiger_Main.jpg": 180
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 169;


//////////////////
// WEBPACK FOOTER
// ./src/assets ^\.\/.*\.jpg$
// module id = 169
// module chunks = 0